export function toUrl(url: string) {
  window.location.assign(url);
}
